export default "__VITE_ASSET__BpIY8Xko__"